import { Color } from '@tiptap/extension-color';
import FontFamily from '@tiptap/extension-font-family';
import TextAlign from '@tiptap/extension-text-align';
import TextStyle from '@tiptap/extension-text-style';
import Underline from '@tiptap/extension-underline';
import StarterKit from '@tiptap/starter-kit';

import { TextWidgetTag } from '../common/TextBasedWidgets.types';
import { CustomLink, CustomListItem, CustomParagraph, FontSize, LineHeight } from '../common/extensions';
import { CustomHeader, EmptyTextStyle } from './extensions';

// these default extensions are included by default in the 'StarterKit' extension
// if we need these extensions later they can be removed from this list
const DISABLED_DEFAULT_EXTENSIONS: { [option: string]: false } = {
  listItem: false,
  paragraph: false,
  heading: false,
  strike: false,
  code: false,
  codeBlock: false,
  blockquote: false,
};

// tiptap extensions for the normal "editable" textwidget
const extensions = [
  CustomLink,
  StarterKit.configure(DISABLED_DEFAULT_EXTENSIONS),
  CustomParagraph,
  CustomListItem,
  TextStyle,
  FontFamily,
  FontSize,
  Underline,
  Color,
  ...[LineHeight, TextAlign].map((extension) => extension.configure({ types: ['paragraph'] })),
  EmptyTextStyle,
];

/**
 * Returns the tiptap extensions for the "read-only" textwidget.
 * Configured for tagging / displaying links
 *
 * @param textTag - the tag of the textwidget
 * @param disableTabbability - whether to disable tabbability on links
 * @returns the prosemirror extensions
 *
 */
const getReadOnlyExtensions = (textTag: TextWidgetTag, disableTabbability: boolean) => {
  const isParagraph = textTag === TextWidgetTag.Paragraph;

  const extensions = [
    CustomLink.configure(
      disableTabbability
        ? // To avoid `tabbability` on links from the thumbnail in the page slide view
          { HTMLAttributes: { tabindex: -1 } }
        : // To fix the issue with links on /pl page not clickable (due to global prosemirror style)
          { HTMLAttributes: { style: 'pointer-events: auto' } },
    ),
    StarterKit.configure(DISABLED_DEFAULT_EXTENSIONS),
    CustomParagraph.configure({ renderTag: isParagraph ? 'p' : 'span' }),
    CustomListItem,
    CustomHeader,
    TextStyle,
    FontFamily,
    FontSize,
    Underline,
    Color,
    ...[LineHeight, TextAlign].map((extension) => extension.configure({ types: ['paragraph'] })),
    EmptyTextStyle,
  ];

  return extensions;
};

export { getReadOnlyExtensions, extensions };
